import React, { useContext } from "react";
import Label from "~/componentes/CustomForm/Label";
import { Input, TextArea, Select } from "~/componentes/CustomForm";
import ColoredButton from "~/componentes/Button/Styles/ColoredButton";
import sistemaListStore from "../../../../../../componentes/SistemaList/ThisMainComponent/thisStore";
import { useState } from "react";
import { useEffect } from "react";

import { CardAtividade, CardTituloAtividade, CardOSAtividade, CardTituloItemAtividade, Container, CardOSItemAtividade } from "./styles";
import IconModalOrcamentoAtividade from '~/assets/icones/modal/IconModalOrcamentoAtividade.svg';
import api from "~/services/api";

function AtividadesList({ defaultData, setter, setterSoma, setterSomaLib, gerarProjeto }) {
  const atividadePad = [
    {
      id: 0,
      dataEmissao: "",
      clientes: [],
      idCliente: 0,
      projetos: [],
      idProjeto: 0,
      atividades: [],
      idProjetoAtividade: 0,
      itensAtividade: [],
      tarefas: [
        {
          id: 0,
          idProjetoAtividadeItem: 0,
          horaInicial: "00:00",
          horaFinal: "00:00",
          horaMinuto: 0,
          descricao: "",
        }
      ],
      horaTotal: 0,
      horaDesconto: "00:00",
      horaTranslado: "00:00",
      descricao: "",
      aberto: true,
    },
  ];
  const [atividades, setAtividades] = useState([]);
  const [analistas, setAnalistas] = useState([]);
  const [projetos, setProjetos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const { state } = useContext(sistemaListStore);
  const { edit, editShow } = state?.modal || {};

  useEffect(() => {
    api.get("/signed/empresa/gestorprojeto/gerencia/analistas").then((r) => setAnalistas(r?.data));
  }, []);

  useEffect(() => {
    setter(atividades);
  }, [atividades]);

  useEffect(() => {
    if (Array.isArray(defaultData)) {
      if (defaultData?.length > 0) {
        if (edit) {
          let aAtividade = [];
          let item = 1;
          for (const itemAtividade of defaultData) {
            let analistas = [];

            if (itemAtividade?.itensAtividade && itemAtividade?.itensAtividade?.length > 0) {
              for (const itemItens of itemAtividade?.itensAtividade) {
                analistas.push({
                  id: itemItens?.id,
                  horaTotal: itemItens?.horaTotal,
                  horaSaldo: itemItens?.horaSaldo,
                  horaUsada: itemItens?.horaUsada,
                  titulo: itemItens?.titulo,
                  descricao: itemItens?.descricao,
                  idAnalista: itemItens?.idAnalista,
                  previsaoInicio: itemItens?.previsaoInicio,
                  dataInicio: itemItens?.dataInicio,
                  previsaoEntrega: itemItens?.previsaoEntrega,
                  dataEntrega: itemItens?.dataEntrega,
                  idProjetoAtividadeAnalista: itemItens?.analistaAtividade?.id,
                });
              }
            }

            for (const itemAnal of itemAtividade?.analistasAtividade) {
              if (!itemAnal?.idProjetoAtividadeItem || itemAnal?.idProjetoAtividadeItem == 0) {
                analistas.push({
                  id: 0,
                  horaTotal: itemAnal?.horaTotal,
                  horaSaldo: itemAnal?.horaSaldo,
                  horaUsada: itemAnal?.horaUsada,
                  titulo: itemAtividade?.titulo,
                  descricao: itemAtividade?.descricao,
                  idAnalista: itemAnal?.idAnalista,
                  previsaoInicio: itemAtividade?.previsaoInicio,
                  dataInicio: itemAtividade?.dataInicio,
                  previsaoEntrega: itemAtividade?.previsaoEntrega,
                  dataEntrega: itemAtividade?.dataEntrega,
                  idProjetoAtividadeAnalista: itemAnal?.id,
                });
              }
            }


            aAtividade.push({
              item,
              id: itemAtividade?.id,
              idDesc: item + (itemAtividade?.orcamento ? ` - SD ${itemAtividade?.orcamento?.id}` : ` - Sem SD`),
              titulo: itemAtividade?.titulo,
              descricao: itemAtividade?.descricao,
              horaTotal: itemAtividade?.horaTotal,
              horaSaldo: itemAtividade?.horaSaldo,
              horaUsada: itemAtividade?.horaUsada,
              dataInicioProjeto: itemAtividade?.previsaoInicio,
              dataPrevEntregaProjeto: itemAtividade?.previsaoEntrega,
              dataEntregaProjeto: itemAtividade?.dataEntrega,
              horasPorDia: itemAtividade?.horasPorDia,
              horaInicial: itemAtividade?.horaInicial,
              horaFinal: itemAtividade?.horaFinal,
              travarSaldo: itemAtividade?.travarSaldo,
              abertoAtividade: false,
              analistas
            });

            item++;
          }
          setAtividades(aAtividade);
          setter(aAtividade);
        }
      } else {
        if (!(edit && editShow)) {
          setAtividades(atividadePad);
          setter(atividadePad);
        }
      }
    }
  }, [edit, editShow]);

  function handleAddAtividade() {
    setAtividades((prev) => [...prev,
    {
      id: 0,
      dataEmissao: "",
      clientes: [],
      idCliente: 0,
      projetos: [],
      idProjeto: 0,
      atividades: [],
      idProjetoAtividade: 0,
      itensAtividade: [],
      tarefas: [
        {
          id: 0,
          idProjetoAtividadeItem: 0,
          horaInicial: "00:00",
          horaFinal: "00:00",
          horaMinuto: 0,
          descricao: "",
        }
      ],
      horaTotal: 0,
      horaDesconto: "00:00",
      horaTranslado: "00:00",
      descricao: "",
      aberto: true,
    },]);
  }

  function handleRemoveAtividade(index) {
    setAtividades((prev) => {
      const newPrev = [...prev];

      newPrev.splice(index, 1);

      return newPrev;
    });
  }

  function handleAddAnalista(index) {
    setAtividades((prev) => {
      let newPrev = [...prev];
      let tarefas = [];
      let horaMinuto = 0;

      for (const itemTarefa of newPrev[index].tarefas) {
        horaMinuto += itemTarefa?.horaMinuto;

        tarefas.push(itemTarefa);
      }

      let totalHoras = Math.floor(horaMinuto / 60);
      let totalMinutos = (horaMinuto % 60) / 100;

      tarefas.push({
        id: 0,
        idProjetoAtividadeItem: 0,
        horaInicial: "00:00",
        horaFinal: "00:00",
        horaTotal: 0,
        descricao: "",
      });
      newPrev[index].tarefas = tarefas;
      newPrev[index].horaTotal = totalHoras + totalMinutos;

      return newPrev;
    });
  }

  function handleRemoveAnalista(index, iAnal) {
    setAtividades((prev) => {
      const newPrev = [...prev];
      let tarefas = [];
      let count = 0;
      let horaMinuto = 0;

      for (const itemTarefa of newPrev[index].tarefas) {
        if (count != iAnal) {
          horaMinuto += itemTarefa?.horaMinuto;

          tarefas.push(itemTarefa);
        }

        count++;
      }

      let totalHoras = Math.floor(horaMinuto / 60);
      let totalMinutos = (horaMinuto % 60) / 100;

      newPrev[index].tarefas = tarefas;
      newPrev[index].horaTotal = totalHoras + totalMinutos;

      return newPrev;
    });
  }

  return (
    <Container>
      <Label title="Atividades *" className="titulo-label" row={true}>
        {!(editShow && edit) ? (
          <ColoredButton small blueLayout type="button" onClick={handleAddAtividade}>
            Adicionar
          </ColoredButton>
        ) : (
          <ColoredButton small disabledLayout type="button">
            Adicionar
          </ColoredButton>
        )}
      </Label>
      <CardAtividade>
        <CardTituloAtividade>
          <div className="col-atv col-1 center">
            <div className="top-header">
              -
            </div>
          </div>
          <div className="col-atv col-2">
            <p className="titulo">Emissão <span>*</span></p>
          </div>
          <div className="col-atv col-2">
            <p className="titulo">Cliente <span>*</span></p>
          </div>
          <div className="col-atv col-4">
            <p className="titulo">Projeto <span>*</span></p>
          </div>
          <div className="col-atv col-4">
            <p className="titulo">Atividade <span>*</span></p>
          </div>
          <div className="col-atv col-1">
            <p className="titulo">Hora Ap</p>
          </div>
          <div className="col-atv col-1">
            <p className="titulo">Desconto </p>
          </div>
          <div className="col-atv col-1">
            <p className="titulo">Translado </p>
          </div>
          {/* <div className="col-atv col-5">
            <p className="titulo">Descrição</p>
          </div> */}
        </CardTituloAtividade>
        {atividades?.map((itemData, index) => (
          <CardOSAtividade>
            <div className="row no-margin row-top">
              <div className="col-atv col-1 center">
                <div className="top-header">
                  <div onClick={(e) => { handleRemoveAtividade(index) }} className="icon-button material-icons">delete</div>
                  <div
                    onClick={(e) => {
                      setAtividades((prev) => {
                        let newPrev = [...prev];

                        newPrev[index].aberto = !newPrev[index].aberto;

                        return newPrev;
                      });
                    }}
                    className="icon-button material-icons"
                  >
                    description
                  </div>
                </div>
              </div>
              <div className="col-atv col-2">
                <Input
                  type="date"
                  name={"dataEmissaoAt" + index}
                  value={itemData?.dataEmissao}
                  onChange={(e) => {
                    const v = e.currentTarget.value || "";

                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].dataEmissao = v;

                      return newPrev;
                    });

                    api.get(
                      "/signed/empresa/gestorprojeto/ordemservicomod2/clientes",
                      { params: { ativo: 1, dataEmissao: v } }
                    ).then((response) => {
                      setAtividades((prev) => {
                        let newPrev = [...prev];

                        newPrev[index].clientes = response?.data;

                        return newPrev;
                      });
                    });
                  }}
                />
              </div>
              <div className="col-atv col-2">
                <Select
                  isString
                  list={{ list: itemData?.clientes, value: "id", label: "nomeFantasia" }}
                  name={"idCliente" + index}
                  firstOption
                  required="true"
                  value={itemData?.idCliente}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;

                    setAtividades((prev) => {
                      const newPrev = [...prev];

                      newPrev[index].idCliente = parseInt(v);

                      return newPrev;
                    });

                    api.get(
                      "/signed/empresa/gestorprojeto/ordemservicomod2/projetos",
                      { params: { ativo: 1, idCliente: v ? v : 0, dataEmissao: itemData?.dataEmissao } }
                    ).then((response) => {
                      setAtividades((prev) => {
                        let newPrev = [...prev];

                        newPrev[index].projetos = response?.data;

                        return newPrev;
                      });
                    });
                  }}
                />
              </div>
              <div className="col-atv col-4">
                <Select
                  isString
                  list={{ list: itemData?.projetos, value: "id", label: "titulo" }}
                  name={"idProjeto" + index}
                  firstOption
                  required="true"
                  value={itemData?.idProjeto}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;

                    setAtividades((prev) => {
                      const newPrev = [...prev];

                      newPrev[index].idProjeto = parseInt(v);

                      const projeto = newPrev[index].projetos?.find((e) => e?.id == parseInt(v));
                      if (projeto) {
                        newPrev[index].atividades = projeto?.atividades;
                      }

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="col-atv col-4">
                <Select
                  isString
                  list={{ list: itemData?.atividades, value: "id", label: "titulo" }}
                  name={"idProjetoAtividade" + index}
                  firstOption
                  required="true"
                  value={itemData?.idProjetoAtividade}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;

                    setAtividades((prev) => {
                      const newPrev = [...prev];

                      newPrev[index].idProjetoAtividade = parseInt(v);

                      const atividade = newPrev[index].atividades?.find((e) => e?.id == parseInt(v));
                      if (atividade) {
                        newPrev[index].itensAtividade = atividade?.itensAtividade;
                      }

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="col-atv col-1 center">
                <Input
                  type="number"
                  name="horaTotalAt"
                  min="1"
                  disabled="true"
                  value={itemData?.horaTotal}
                />
              </div>
              <div className="col-atv col-1 center">
                <Select
                  isString
                  list={{
                    list: [
                      { id: '00:00', titulo: '00:00' },
                      { id: '00:15', titulo: '00:15' },
                      { id: '00:30', titulo: '00:30' },
                      { id: '00:45', titulo: '00:45' },
                      { id: '01:00', titulo: '01:00' },
                      { id: '01:15', titulo: '01:15' },
                      { id: '01:30', titulo: '01:30' },
                      { id: '01:45', titulo: '01:45' },
                      { id: '02:00', titulo: '02:00' },
                      { id: '02:15', titulo: '02:15' },
                      { id: '02:30', titulo: '02:30' },
                      { id: '02:45', titulo: '02:45' },
                      { id: '03:00', titulo: '03:00' },
                      { id: '03:15', titulo: '03:15' },
                      { id: '03:30', titulo: '03:30' },
                      { id: '03:45', titulo: '03:45' },
                      { id: '04:00', titulo: '04:00' },
                      { id: '04:15', titulo: '04:15' },
                      { id: '04:30', titulo: '04:30' },
                      { id: '04:45', titulo: '04:45' },
                      { id: '05:00', titulo: '05:00' },
                      { id: '05:15', titulo: '05:15' },
                      { id: '05:30', titulo: '05:30' },
                      { id: '05:45', titulo: '05:45' },
                      { id: '06:00', titulo: '06:00' },
                      { id: '06:15', titulo: '06:15' },
                      { id: '06:30', titulo: '06:30' },
                      { id: '06:45', titulo: '06:45' },
                      { id: '07:00', titulo: '07:00' },
                      { id: '07:15', titulo: '07:15' },
                      { id: '07:30', titulo: '07:30' },
                      { id: '07:45', titulo: '07:45' },
                      { id: '08:00', titulo: '08:00' },
                      { id: '08:15', titulo: '08:15' },
                      { id: '08:30', titulo: '08:30' },
                      { id: '08:45', titulo: '08:45' },
                      { id: '09:00', titulo: '09:00' },
                      { id: '09:15', titulo: '09:15' },
                      { id: '09:30', titulo: '09:30' },
                      { id: '09:45', titulo: '09:45' },
                      { id: '10:00', titulo: '10:00' },
                      { id: '10:15', titulo: '10:15' },
                      { id: '10:30', titulo: '10:30' },
                      { id: '10:45', titulo: '10:45' },
                      { id: '11:00', titulo: '11:00' },
                      { id: '11:15', titulo: '11:15' },
                      { id: '11:30', titulo: '11:30' },
                      { id: '11:45', titulo: '11:45' },
                      { id: '12:00', titulo: '12:00' },
                      { id: '12:15', titulo: '12:15' },
                      { id: '12:30', titulo: '12:30' },
                      { id: '12:45', titulo: '12:45' },
                      { id: '13:00', titulo: '13:00' },
                      { id: '13:15', titulo: '13:15' },
                      { id: '13:30', titulo: '13:30' },
                      { id: '13:45', titulo: '13:45' },
                      { id: '14:00', titulo: '14:00' },
                      { id: '14:15', titulo: '14:15' },
                      { id: '14:30', titulo: '14:30' },
                      { id: '14:45', titulo: '14:45' },
                      { id: '15:00', titulo: '15:00' },
                      { id: '15:15', titulo: '15:15' },
                      { id: '15:30', titulo: '15:30' },
                      { id: '15:45', titulo: '15:45' },
                      { id: '16:00', titulo: '16:00' },
                      { id: '16:15', titulo: '16:15' },
                      { id: '16:30', titulo: '16:30' },
                      { id: '16:45', titulo: '16:45' },
                      { id: '17:00', titulo: '17:00' },
                      { id: '17:15', titulo: '17:15' },
                      { id: '17:30', titulo: '17:30' },
                      { id: '17:45', titulo: '17:45' },
                      { id: '18:00', titulo: '18:00' },
                      { id: '18:15', titulo: '18:15' },
                      { id: '18:30', titulo: '18:30' },
                      { id: '18:45', titulo: '18:45' },
                      { id: '19:00', titulo: '19:00' },
                      { id: '19:15', titulo: '19:15' },
                      { id: '19:30', titulo: '19:30' },
                      { id: '19:45', titulo: '19:45' },
                      { id: '20:00', titulo: '20:00' },
                      { id: '20:15', titulo: '20:15' },
                      { id: '20:30', titulo: '20:30' },
                      { id: '20:45', titulo: '20:45' },
                      { id: '21:00', titulo: '21:00' },
                      { id: '21:15', titulo: '21:15' },
                      { id: '21:30', titulo: '21:30' },
                      { id: '21:45', titulo: '18:45' },
                      { id: '22:00', titulo: '22:00' },
                      { id: '22:15', titulo: '22:15' },
                      { id: '22:30', titulo: '22:30' },
                      { id: '22:45', titulo: '22:45' },
                      { id: '23:00', titulo: '23:00' },
                      { id: '23:15', titulo: '23:15' },
                      { id: '23:30', titulo: '23:30' },
                      { id: '23:45', titulo: '23:45' },
                    ],
                    value: 'id',
                    label: 'titulo',
                  }}
                  value={itemData?.horaDesconto}
                  name={"horaDesconto" + index}
                  onChange={(e) => {
                    const v = e.currentTarget.value || "00:00";

                    setAtividades((prev) => {
                      const newPrev = [...prev];

                      newPrev[index].horaDesconto = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="col-atv col-1 center">
                <Select
                  isString
                  list={{
                    list: [
                      { id: '00:00', titulo: '00:00' },
                      { id: '00:15', titulo: '00:15' },
                      { id: '00:30', titulo: '00:30' },
                      { id: '00:45', titulo: '00:45' },
                      { id: '01:00', titulo: '01:00' },
                      { id: '01:15', titulo: '01:15' },
                      { id: '01:30', titulo: '01:30' },
                      { id: '01:45', titulo: '01:45' },
                      { id: '02:00', titulo: '02:00' },
                      { id: '02:15', titulo: '02:15' },
                      { id: '02:30', titulo: '02:30' },
                      { id: '02:45', titulo: '02:45' },
                      { id: '03:00', titulo: '03:00' },
                      { id: '03:15', titulo: '03:15' },
                      { id: '03:30', titulo: '03:30' },
                      { id: '03:45', titulo: '03:45' },
                      { id: '04:00', titulo: '04:00' },
                      { id: '04:15', titulo: '04:15' },
                      { id: '04:30', titulo: '04:30' },
                      { id: '04:45', titulo: '04:45' },
                      { id: '05:00', titulo: '05:00' },
                      { id: '05:15', titulo: '05:15' },
                      { id: '05:30', titulo: '05:30' },
                      { id: '05:45', titulo: '05:45' },
                      { id: '06:00', titulo: '06:00' },
                      { id: '06:15', titulo: '06:15' },
                      { id: '06:30', titulo: '06:30' },
                      { id: '06:45', titulo: '06:45' },
                      { id: '07:00', titulo: '07:00' },
                      { id: '07:15', titulo: '07:15' },
                      { id: '07:30', titulo: '07:30' },
                      { id: '07:45', titulo: '07:45' },
                      { id: '08:00', titulo: '08:00' },
                      { id: '08:15', titulo: '08:15' },
                      { id: '08:30', titulo: '08:30' },
                      { id: '08:45', titulo: '08:45' },
                      { id: '09:00', titulo: '09:00' },
                      { id: '09:15', titulo: '09:15' },
                      { id: '09:30', titulo: '09:30' },
                      { id: '09:45', titulo: '09:45' },
                      { id: '10:00', titulo: '10:00' },
                      { id: '10:15', titulo: '10:15' },
                      { id: '10:30', titulo: '10:30' },
                      { id: '10:45', titulo: '10:45' },
                      { id: '11:00', titulo: '11:00' },
                      { id: '11:15', titulo: '11:15' },
                      { id: '11:30', titulo: '11:30' },
                      { id: '11:45', titulo: '11:45' },
                      { id: '12:00', titulo: '12:00' },
                      { id: '12:15', titulo: '12:15' },
                      { id: '12:30', titulo: '12:30' },
                      { id: '12:45', titulo: '12:45' },
                      { id: '13:00', titulo: '13:00' },
                      { id: '13:15', titulo: '13:15' },
                      { id: '13:30', titulo: '13:30' },
                      { id: '13:45', titulo: '13:45' },
                      { id: '14:00', titulo: '14:00' },
                      { id: '14:15', titulo: '14:15' },
                      { id: '14:30', titulo: '14:30' },
                      { id: '14:45', titulo: '14:45' },
                      { id: '15:00', titulo: '15:00' },
                      { id: '15:15', titulo: '15:15' },
                      { id: '15:30', titulo: '15:30' },
                      { id: '15:45', titulo: '15:45' },
                      { id: '16:00', titulo: '16:00' },
                      { id: '16:15', titulo: '16:15' },
                      { id: '16:30', titulo: '16:30' },
                      { id: '16:45', titulo: '16:45' },
                      { id: '17:00', titulo: '17:00' },
                      { id: '17:15', titulo: '17:15' },
                      { id: '17:30', titulo: '17:30' },
                      { id: '17:45', titulo: '17:45' },
                      { id: '18:00', titulo: '18:00' },
                      { id: '18:15', titulo: '18:15' },
                      { id: '18:30', titulo: '18:30' },
                      { id: '18:45', titulo: '18:45' },
                      { id: '19:00', titulo: '19:00' },
                      { id: '19:15', titulo: '19:15' },
                      { id: '19:30', titulo: '19:30' },
                      { id: '19:45', titulo: '19:45' },
                      { id: '20:00', titulo: '20:00' },
                      { id: '20:15', titulo: '20:15' },
                      { id: '20:30', titulo: '20:30' },
                      { id: '20:45', titulo: '20:45' },
                      { id: '21:00', titulo: '21:00' },
                      { id: '21:15', titulo: '21:15' },
                      { id: '21:30', titulo: '21:30' },
                      { id: '21:45', titulo: '18:45' },
                      { id: '22:00', titulo: '22:00' },
                      { id: '22:15', titulo: '22:15' },
                      { id: '22:30', titulo: '22:30' },
                      { id: '22:45', titulo: '22:45' },
                      { id: '23:00', titulo: '23:00' },
                      { id: '23:15', titulo: '23:15' },
                      { id: '23:30', titulo: '23:30' },
                      { id: '23:45', titulo: '23:45' },
                    ],
                    value: 'id',
                    label: 'titulo',
                  }}
                  value={itemData?.horaTranslado}
                  name={"horaTranslado" + index}
                  onChange={(e) => {
                    const v = e.currentTarget.value || "00:00";

                    setAtividades((prev) => {
                      const newPrev = [...prev];

                      newPrev[index].horaTranslado = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              {/* <div className="col-atv col-5">
                <TextArea
                  placeholder="Descrição da Atividade"
                  name={"descAtividadeAt" + index}
                  value={itemData?.descricao}
                  onChange={(e) => {
                    const v = e.currentTarget.value || "";

                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].descricao = v;

                      return newPrev;
                    });
                  }}
                />
              </div> */}
            </div>
            <div className="sub-atividade">
              <CardTituloItemAtividade>
                <div className="col-atv-item col-1 center">
                  <div className="top-header">
                    {!(editShow && edit) ? (
                      <ColoredButton small blueLayout type="button" onClick={() => { handleAddAnalista(index) }}>
                        +
                      </ColoredButton>
                    ) : (
                      <ColoredButton small disabledLayout type="button">
                        +
                      </ColoredButton>
                    )}
                  </div>
                </div>
                <div className="col-atv-item col-2">
                  <p className="titulo">Hora Inicial <span>*</span></p>
                </div>
                <div className="col-atv-item col-2">
                  <p className="titulo">Hora Final <span>*</span></p>
                </div>
                <div className="col-atv-item col-5">
                  <p className="titulo">Tarefa <span>*</span></p>
                </div>
                <div className="col-atv-item col-6">
                  <p className="titulo">Descrição</p>
                </div>
              </CardTituloItemAtividade>
              {itemData?.tarefas?.map((itemTarefa, indexTarefa) => (
                <CardOSItemAtividade>
                  <div className="row no-margin row-top">
                    <div className="col-atv-item col-1 center">
                      <div className="top-header">
                        {itemTarefa?.horaUsada == 0 || !itemTarefa?.horaUsada ? (<div onClick={(e) => { handleRemoveAnalista(index, indexTarefa) }} className="icon-button material-icons">delete</div>) : <div />}
                      </div>
                    </div>
                    <div className="col-atv-item col-2">
                      <Input
                        type="time"
                        name={"horaInicialTarefa" + indexTarefa}
                        required="true"
                        value={itemTarefa?.horaInicial}
                        onChange={(e) => {
                          const v = e.currentTarget.value || "";
                          setAtividades((prev) => {
                            let newPrev = [...prev];

                            let listaTarefas = [];
                            let count = 0;
                            let totalMinutos = 0;

                            for (const item of newPrev[index]?.tarefas) {
                              if (count == indexTarefa) {
                                let [horaIni, minutoIni] = v.split(':').map(value => parseInt(value));
                                let [horaFim, minutoFim] = itemTarefa?.horaFinal.split(':').map(value => parseInt(value));
                                let totalMinuto = ((horaFim * 60) + minutoFim) - ((horaIni * 60) + minutoIni);

                                listaTarefas.push({ ...item, horaInicial: v, horaMinuto: totalMinuto < 0 ? 0 : totalMinuto });
                              } else {
                                listaTarefas.push(item);
                              }

                              totalMinutos += listaTarefas[count]?.horaMinuto;

                              count++;
                            }
                            newPrev[index].tarefas = listaTarefas;
                            newPrev[index].horaTotal = Math.floor(totalMinutos / 60) + ((totalMinutos % 60) / 100);

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                    <div className="col-atv-item col-2">
                      <Input
                        type="time"
                        name={"horaFinalTarefa" + indexTarefa}
                        required="true"
                        value={itemTarefa?.horaFinal}
                        onChange={(e) => {
                          const v = e.currentTarget.value || "";
                          setAtividades((prev) => {
                            let newPrev = [...prev];

                            let listaTarefas = [];
                            let count = 0;
                            let totalMinutos = 0;

                            for (const item of newPrev[index]?.tarefas) {
                              if (count == indexTarefa) {
                                let [horaIni, minutoIni] = itemTarefa?.horaInicial.split(':').map(value => parseInt(value));
                                let [horaFim, minutoFim] = v.split(':').map(value => parseInt(value));
                                let totalMinuto = ((horaFim * 60) + minutoFim) - ((horaIni * 60) + minutoIni);

                                listaTarefas.push({ ...item, horaFinal: v, horaMinuto: totalMinuto < 0 ? 0 : totalMinuto });
                              } else {
                                listaTarefas.push(item);
                              }

                              totalMinutos += listaTarefas[count]?.horaMinuto;

                              count++;
                            }
                            newPrev[index].tarefas = listaTarefas;
                            newPrev[index].horaTotal = Math.floor(totalMinutos / 60) + ((totalMinutos % 60) / 100);

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                    <div className="col-atv-item col-5">
                      <Select
                        isString
                        list={{ list: itemData?.itensAtividade, value: "id", label: "titulo" }}
                        name={"idProjetoAtividadeItem" + indexTarefa}
                        firstOption
                        required="true"
                        onChange={(e) => {
                          const v = e.currentTarget.value || 0;
                          setAtividades((prev) => {
                            const newPrev = [...prev];
                            let tarefas = [];
                            let count = 0;

                            for (const item of newPrev[index].tarefas) {
                              if (count == indexTarefa) {
                                tarefas.push({ ...item, idProjetoAtividadeItem: parseInt(v) });
                              } else {
                                tarefas.push(item);
                              }

                              count++;
                            }
                            newPrev[index].tarefas = tarefas;

                            return newPrev;
                          });
                        }}
                        value={itemTarefa?.idProjetoAtividadeItem}
                      />
                    </div>
                    <div className="col-atv-item col-6">
                      <TextArea
                        placeholder="Descrição da Atividade"
                        name={"descricaoTarefa" + indexTarefa}
                        value={itemTarefa?.descricao}
                        onChange={(e) => {
                          const v = e.currentTarget.value || "";
                          setAtividades((prev) => {
                            const newPrev = [...prev];
                            let tarefas = [];
                            let count = 0;

                            for (const item of newPrev[index].tarefas) {
                              if (count == indexTarefa) {
                                tarefas.push({ ...item, descricao: v });
                              } else {
                                tarefas.push(item);
                              }

                              count++;
                            }
                            newPrev[index].tarefas = tarefas;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                  </div>
                </CardOSItemAtividade>
              ))}
            </div>
          </CardOSAtividade>
        ))}
      </CardAtividade>
    </Container>
  );
}

export default AtividadesList;
